import React from 'react'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../lib/ui/select'
import { useTranslation } from '../../hooks/useTranslation'
import { useActionPlan } from './ActionPlanProvider'

export const useTimelineKeys = (t, goal) => {
  let keys = t('timeline_options')
  if (goal?.toLowerCase() === 'retirement') {
    const retirementTimelineOptions = t('retirement_timeline_options')
    keys = {
      ...Object.fromEntries(Object.entries(keys).slice(0, 4)),
      ...retirementTimelineOptions,
    }
  }
  return keys
}

const SetTimelineForm = ({ setNewTimeline }) => {
  const { t } = useTranslation()
  const { goal, desiredTimeline } = useActionPlan()
  const timelineKeys = useTimelineKeys(t, goal)

  return (
    <div className="flex flex-col gap-4 px-6 pt-1">
      <div>{t('please_select_timeline')}</div>
      <Select
        onValueChange={(v) => setNewTimeline(v)}
        defaultValue={
          desiredTimeline != null ? String(desiredTimeline) : undefined
        }
      >
        <SelectTrigger
          className="sm:w-4/6"
          aria-label={t('please_select_timeline')}
        >
          <SelectValue placeholder={t('select_an_option')} />
        </SelectTrigger>
        <SelectContent>
          {Object.entries(timelineKeys).map(([key, value]) => (
            <SelectItem key={key} value={key}>
              {value}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}
export default SetTimelineForm
